module.exports = __webpack_public_path__ + "media/images/home/user-profile-ff0d23ed1b858bd0427c4668fe1a058c.png";